module.exports = __webpack_public_path__ + "img/collection-weddingRingsSignature@2x.f47468c.jpg";